import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

const TONES: Record<Tone, string> = {
  // Muted text on the muted fill is too faint to read at this size.
  neutral: 'bg-muted text-foreground/80',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-900',
  danger: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
};

interface StatusPillProps {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

// A small label for a state. The text always says the state; color only backs it up.
export default function StatusPill({ tone = 'neutral', children, className }: StatusPillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONES[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
